export enum EngagementMediaType {
  Image = 'image',
  Video = 'video',
  DirectShow = 'directshow',
  Livestream = 'livestream',
}
